import React, { Component } from "react";
import DropzoneComponent from "react-dropzone-component";
import "dropzone/dist/min/dropzone.min.css";
import { toastr } from "react-redux-toastr";
import { upload, uploads3Url } from "../../actions/leakedCode";
var Model = require("../information/model");

class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      fileName: ""
    };
    this.dropzoneRef = React.createRef();
  }

  clearSpecificFile = (file) => {
    if (this.dropzoneRef.current) {
      this.dropzoneRef.current.dropzone.removeFile(file);
    }
    
    this.setState(prevState => ({
      files: prevState.files.filter(f => f !== file)
    }));

    if (this.props.onDelete) {
      this.props.onDelete(file);
    }
  };

  clearAllFiles = () => {
    if (this.dropzoneRef.current) {
      this.dropzoneRef.current.dropzone.removeAllFiles();
    }
    this.setState({ files: [], fileName: "" });
  };

  componentDidUpdate(prevProps) {
    if (this.props.reset && !prevProps.reset) {
      this.clearAllFiles();
      if (this.props.onReset) {
        this.props.onReset();
      }
    }
  }

  render() {
    var componentConfig = { postUrl: "no-url" };
    var djsConfig = { 
      autoProcessQueue: false,
      addRemoveLinks: false,
      previewTemplate: `
        <div class="dz-preview dz-file-preview" data-file-id="">
          <div class="dz-image">
            <img data-dz-thumbnail />
          </div>
          <div class="dz-details">
            <div class="dz-filename"><span data-dz-name></span></div>
            <div class="dz-size" data-dz-size></div>
          </div>
          <div class="dz-remove-button" style="
            position: absolute;
            top: 5px;
            right: 5px;
            background: #ff4444;
            color: white;
            border: none;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 14px;
            z-index: 1000;
          ">×</div>
        </div>
      `
    };
    
    var eventHandlers = {
      addedfile: (file) => {
        // Generate a unique ID for this file
        file.uniqueId = `file_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        
        this.setState(prevState => ({
          files: [...prevState.files, file]
        }));
        
        // Add click handler for remove button after file is added
        setTimeout(() => {
          // Find the preview element for this specific file
          const previewElement = file.previewElement;
          if (previewElement) {
            // Set the unique ID on the preview element
            previewElement.setAttribute('data-file-id', file.uniqueId);
            
            // Find the remove button within this specific preview element
            const removeButton = previewElement.querySelector('.dz-remove-button');
            if (removeButton) {
              removeButton.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.clearSpecificFile(file);
              };
            }
          }
        }, 0);
        
        if (this.props.isUpload && this.props.isUpload === "false") {
          this.setState({
            fileName: file.upload.filename?.replace(".json",'')
          });
          var reader = new FileReader();
          reader.onload = onReaderLoad;
          reader.readAsText(file);
        } else {
          uploads3Url(file, this.props.data).then((res) => {
            this.props.variable(res);
          });
        }
      },
      removedfile: (file) => {
        this.setState(prevState => ({
          files: prevState.files.filter(f => f !== file)
        }));
      }
    };

    const onReaderLoad = (event) => {
      try {
        var obj = JSON.parse(event.target.result);
        this.props.variable(obj);
        this.props.setProjectId(obj?.project_id);
        this.props.setEmail(obj?.client_email);
        this.props.setPrivateKey(obj?.private_key);
        this.props.setName(this.state.fileName);
      } catch(err) {
        toastr.error("Error", "Please upload json file.");
      }
    };

    return (
      <div>
        <DropzoneComponent
          ref={this.dropzoneRef}
          config={componentConfig}
          eventHandlers={eventHandlers}
          className="dropify"
          djsConfig={djsConfig}
          {...this.props}
        />
      </div>
    );
  }
}

export default Dropzone;